<template>
  <div class="content-cards" :class="{ margin: fields?.margin?.value === true }">
    <sc-placeholder name="jss-content-cards" :rendering="rendering" />
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Content-Cards',
  components: {
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.content-cards {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  &.margin {
    @include padding-x-thin;
  }
}
</style>
